import { Injectable, Injector } from '@angular/core';
import {Http, Response, RequestOptions, RequestOptionsArgs, XHRBackend} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/throw';
import {ServiceName} from './Service';
import {environment} from '../../../environments/environment';
import {AUTH_REFRESH_SERVICE} from '../../auth/auth-refresh-service.token';

@Injectable()
export class HttpService extends Http {
  private _options: RequestOptionsArgs;
  constructor (backend: XHRBackend, options: RequestOptions, private injector: Injector) {
     super(backend, options);
  }

  private getOptions(options?: RequestOptionsArgs): RequestOptionsArgs {
    if (this._options) {
      if (options) {
        options = Object.assign(options, this._options);
      }else {
        options = this._options;
      }
    }
    return options;
  }

  // On 401, delegate to the shared refresh coordinator; the retry re-issues the
  // same call via super.* (unwrapped) so it cannot recurse. The refresh endpoint
  // is excluded outright.
  private wrap(url: string, call: () => Observable<Response>): Observable<Response> {
    // Refresh is excluded (it IS the 401 recovery). Login/2FA-verify are also excluded: they are
    // pre-session, so a 401 there means bad credentials / wrong code, NOT an expired access token --
    // routing it through the refresh coordinator would fire a pointless refresh and swallow the error
    // the login screen needs to show. Let those 401s propagate straight to the caller's catch.
    if (url && (url.indexOf(environment.refreshUrl) !== -1 || url.indexOf('/login') !== -1)) {
      return call();
    }
    return call().catch((err: any) => {
      if (err && err.status === 401) {
        const refresher = this.injector.get(AUTH_REFRESH_SERVICE);
        return refresher.handle401(() => call());
      }
      return Observable.throw(err);
    });
  }

  get(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.wrap(url, () => super.get(url, this.getOptions(options)));
  }

  post(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    return this.wrap(url, () => super.post(url, body, this.getOptions(options)));
  }

  put(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    return this.wrap(url, () => super.put(url, body, this.getOptions(options)));
  }

  delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.wrap(url, () => super.delete(url, this.getOptions(options)));
  }

  patch(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    return this.wrap(url, () => super.patch(url, body, this.getOptions(options)));
  }

  head(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return super.head(url, this.getOptions(options));
  }

  options(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return super.options(url, this.getOptions(options));
  }

  setOptions(options: RequestOptionsArgs) {
    this._options = options;
  }
  deleteOptions() {
    this._options = null;
  }
}

ServiceName.add('HttpService', HttpService);



// WEBPACK FOOTER //
// ./src/app/core/services/http.service.ts